import { render, staticRenderFns } from "./BrandWall.vue?vue&type=template&id=eb084a30&scoped=true"
import script from "./BrandWall.vue?vue&type=script&lang=js"
export * from "./BrandWall.vue?vue&type=script&lang=js"
import style0 from "./BrandWall.vue?vue&type=style&index=0&id=eb084a30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb084a30",
  null
  
)

export default component.exports